import React, { useContext } from "react";

import { AppRulesContext } from "../App";
import { IPermissionConfig } from "../config/interfaces";

type Props = {
	rules?: IPermissionConfig | null;
	behavior: "hide" | "disable";
	children: JSX.Element;
};

const GuardedComponent: React.FC<Props> = (props: Props) => {
	const { behavior, children, rules } = props;

	const { rulesSvc } = useContext(AppRulesContext);

	if (rules) {
		const canAccess = rulesSvc.canAccess(rules);
		if (canAccess) {
			return children;
		}
		// TODO: consider the cases for "behavior"
		return null;
	}

	return null;
};

export default GuardedComponent;
